import { useTranslation } from 'react-i18next';

type FeedbackProps = {
  feedbackUrl: string;
};

export const Feedback = ({ feedbackUrl }: FeedbackProps) => {
  const { t } = useTranslation();

  return (
    <div className="top-1/2 right-4 z-50 fixed origin-right -rotate-90">
      <a
        href={feedbackUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 bg-[#A7AD2A] hover:bg-[#bfc731] px-4 py-2 rounded-t-[16px] font-medium text-white transition-colors hover:scale-105"
      >
        {t('feedback')}
      </a>
    </div>
  );
};
